export const SAVE = 'collisionDamageStarrStep.SAVE';
export const VALUE_CHANGED = 'collisionDamageStarrStep.VALUE_CHANGED';
export const LOAD = 'collisionDamageStarrStep.VALUE_LOAD';
export const NEXT = 'collisionDamageStarrStep.NEXT';
export const RESET = 'collisionDamageStarrStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'collisionDamageStarrStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'collisionDamageStarrStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'collisionDamageStarrStep.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'collisionDamageStarrStep.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'collisionDamageStarrStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'collisionDamageStarrStep.RESET_TRAVEL_DELAY_STATE';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'collisionDamageStarrStep.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'collisionDamageStarrStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_EUROPEAN_UNION_STATE = 'collisionDamageStarrStep.RESET_EUROPEAN_UNION_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepCollisionDamage/constants.js